import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { Filter } from '../../../types/Filter';

type SaveUserFilterParams = Pick<Filter, 'name' | 'page' | 'content'>;

export const saveUserFilter = async (formData: SaveUserFilterParams): Promise<Filter> => {
  const response = await CustomAxios.put(`user-filter`, formData);
  const { data } = response;
  return data;
};

export function useSaveUserFilter() {
  return useMutation({
    mutationFn: async (formData: SaveUserFilterParams) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserFilters, formData.page] });
      return await saveUserFilter(formData);
    },
    onSuccess: (data: Filter) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserFilters, data.page] });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: Filter = err.response.data as Filter;
        alert("Unable to save filter");
      }
    },
  });
}
